import classNames from 'classnames'
import * as PropTypes from 'prop-types'
import React from 'react'

import { SectionContainer, SectionUptitle, SliderReviews } from '../../../components'
import ReviewSlide from '../../../components/ReviewSlide'
import { chainDecorators, memoized } from '../../../utils/ReactUtils'

import styles from './styles'


const decorators = [
  memoized,
]

function HomeReviews({ reviews, sectionTitle }) {

  return (
      <SectionContainer className="reviews">
        <SectionUptitle title={sectionTitle} />
        <SliderReviews reviews={reviews} />
        <style jsx>{styles}</style>
      </SectionContainer>
    )
}

HomeReviews.propTypes = {
  sectionTitle: PropTypes.string,
  reviews: PropTypes.arrayOf(PropTypes.shape(ReviewSlide.propTypes))
}

HomeReviews.defaultProps = {
  sectionTitle: '',
  reviews: []
}

HomeReviews = chainDecorators(decorators, HomeReviews)

export default HomeReviews
